import React, { useEffect, useState } from 'react';
import CustomContainer from '../../../components/CustomContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { Actions } from '../../../../client/Actions';
import ReservationSummary from './ReservationSummary';
import CustomCard from '../../../components/CustomCard';
import HouseHeader from '../../../components/lakeview/HouseHeader';
import DatesGuestsCard from './DatesGuestsCard';
import ReservationHeader from './ReservationHeader';
import FunctionalTableComponent from '../../../components/table/FunctionalTableComponent';
import PaymentTransactionTableConfig from '../../transactions/PaymentTransactionTableConfig';
import PaymentTransactionFormConfig from '../../transactions/PaymentTransactionFormConfig';
import { Col } from 'react-bootstrap';
import ReservationPaymentSummary from './ReservationPaymentSummary';
import DivBetween from '../../../components/div/DivBetween';
import LightButton from '../../../components/button/LightButton';
import ReservationCustomerSummary from './ReservationCustomerSummary';
import AcceptedLegalDocumentTableConfig from './AcceptedLegalDocumentTableConfig';
import SentMailsComponent from '../../send-mail/SentMailsComponent';
import AccountingDocumentComponent from '../../accounting-document/AccountingDocumentComponent';
import ReservationTimeline from '../../../components/lakeview/ReservationTimeline';

const ReservationDetailsPage = () => {
  let { id } = useParams();

  const [reservation, setReservation] = useState();
  const navigate = useNavigate();

  function loadReservation() {
    Actions.get('reservation/' + id, setReservation);
  }

  useEffect(() => {
    loadReservation();
  }, [id]);

  if (!reservation) {
    return <></>;
  }


  return (
    <CustomContainer
      key={
        reservation.updatedAt ||
        reservation.id ||
        reservation.transactions.length
      }
      title={
        <ReservationHeader
          onReload={loadReservation}
          reservation={reservation}
        />
      }
    >
      <Col md={8}>
        <CustomCard
          title={
            <DivBetween>
              Domek
              <LightButton
                onClick={() => {
                  navigate('/house/' + reservation.houses[0].id+"/details");
                }}
              >
                Szczegóły
              </LightButton>
            </DivBetween>
          }
          shadow={false}
        >
          {reservation.houses.map((house) => (
            <HouseHeader house={house} />
          ))}
        </CustomCard>

        <CustomCard title={'Kto i kiedy przyjeżdża'} shadow={false}>
          <DatesGuestsCard reservation={reservation} />
        </CustomCard>

        <CustomCard title={'Szczegóły rezerwacji'} shadow={false}>
          <ReservationSummary withoutTitle={true} reservation={reservation} />
        </CustomCard>

        <FunctionalTableComponent
          key={reservation?.transactions.length}
          shadow={false}
          title={'Płatności'}
          columns={PaymentTransactionTableConfig}
          header={true}
          initialData={reservation.transactions}
          removable={true}
          modalSize={'md'}
          deleteApi={'payment-transaction'}
          createApi={'payment-transaction'}
          creationTitle={'Dodanie płatności'}
          creationFields={PaymentTransactionFormConfig}
          deleteModalTitle={'Usunięcie płatności'}
          deleteModalDescription={'Czy na pewno chcesz usunąć płatność?'}
          editable={false}
          onDeleted={loadReservation}
          onCreated={loadReservation}
          tableExport={true}
          beforeSave={(data) => {
            data.reservationId = id;
            return data;
          }}
          width={12}
        />

        <ReservationCustomerSummary
          reservation={reservation}
          setReservation={setReservation}
        />

        <ReservationTimeline
          cancellationRules={reservation.cancellationRules}
          arrivalDate={reservation.startDate}
          departureDate={reservation.endDate}
          currentRefundStatus={reservation.currentRefundStatus}
        />

        <FunctionalTableComponent
          shadow={false}
          title={'Zatwierdzone dokumenty'}
          columns={AcceptedLegalDocumentTableConfig}
          header={true}
          trick="Tutaj znajdziesz wersje dokumentów (regulamin, polityka prywatności, zasady anulowania), które użytkownik zaakceptował podczas dokonywania rezerwacji."
          initialData={reservation.acceptedLegalDocuments}
          removable={false}
          editable={false}
          width={12}
        />

        <AccountingDocumentComponent reservationId={id}/>

        <SentMailsComponent reservationId={id} />

      </Col>
      <Col md={4}>
        <ReservationPaymentSummary
          key={reservation?.transactions.length}
          reloadData={loadReservation}
          reservation={reservation}
        />
      </Col>
    </CustomContainer>
  );
};

export default ReservationDetailsPage;
